import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as stockActions from "../../../../../actions/stockActions";
import * as barcodeActions from "../../../../../actions/barcodeActions";
import * as modelHelper from "../../../../../helpers/modelHelper";

import imgCar from "../../../../../resources/img/svgicons/car.svg";
import imgPrediction from "../../../../../resources/img/svgicons/prediction.svg";
import imgWarning from "../../../../../resources/img/svgicons/warning.svg";

import Button from "../../../../global/generic/Button";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../../global/generic/Table";
import BarcodeImage from "../../../../global/BarcodeImage";
import Modal from "../../../../global/generic/Modal";

class EditColorantPackageInStockModal extends Component {
    constructor(props) {
        super(props);

        const cp = this.props.colorantPackages.find(
            (colorantPackage) => colorantPackage.key === this.props.params.colorantPackageKey
        );

        this.props.dispatchGetBarcodeAction(cp.item.colorant.name, cp.item.package.name);

        this.state = {
            colorantPackage: cp
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const colorantPackage = nextProps.colorantPackages.find(
            (colorantPackage) => colorantPackage.key === nextProps.params.colorantPackageKey
        );

        if (colorantPackage !== prevState.colorantPackage && colorantPackage) {
            return {
                colorantPackage: colorantPackage
            };
        }

        return null;
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseEditColorantPackagesInStockModalAction();
    };

    handleSubmit = () => {
        this.props.params.addColorantPackagesToStock(this.state.colorantPackagesToAdd);
    };

    handleRemoveColorantPackageClick = () => {
        this.props.dispatchRemoveColorantPackageFromStockAction(
            modelHelper.buildColorantPackageStock(
                this.state.colorantPackage.key,
                this.state.colorantPackage.item.package.name,
                this.state.colorantPackage.item.colorant.name
            )
        );
    };

    calculateToOrder = () => {
        return (
            this.state.colorantPackage.prediction -
            (this.state.colorantPackage.ordered + this.state.colorantPackage.currentValue)
        );
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.package" />),
            modelHelper.buildTableCell(<Translate value="general.batchNumber" />),
            modelHelper.buildTableCell(<Translate value="stock.expirationDate" />),
            modelHelper.buildTableCell(<Translate value="stock.addedToStock" />),
            modelHelper.buildTableCell("")
        ]);
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-2 text-center vertical-center"),
            modelHelper.buildTableColumn("col-3 text-center vertical-center"),
            modelHelper.buildTableColumn("col-3 text-center vertical-center"),
            modelHelper.buildTableColumn("col-3 text-center vertical-center"),
            modelHelper.buildTableColumn("col-1 text-center vertical-center")
        ];
    };

    getTableRows = () => {
        return [...Array(this.state.colorantPackage.currentValue)].map((x, i) => {
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(this.state.colorantPackage.item.package.displayName),
                    modelHelper.buildTableCell(""),
                    modelHelper.buildTableCell(""),
                    modelHelper.buildTableCell(""),
                    modelHelper.buildTableCell(
                        <Button
                            className="force-square size50x50 flex-align-center"
                            onClick={this.handleRemoveColorantPackageClick}
                            label={<span className="glyphicon glyphicon-remove" />}
                        />,
                        "text-right"
                    )
                ],
                "",
                i
            );
        });
    };

    getColorantPackageStockInfo = () => {
        return (
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    isSafe = () => {
        return (
            this.state.colorantPackage.currentValue + this.state.colorantPackage.ordered >=
            this.state.colorantPackage.minValue
        );
    };

    getWarning = () => {
        return this.state.colorantPackage.currentValue + this.state.colorantPackage.ordered <
            this.state.colorantPackage.minValue ? (
            <img className="margin-left-5 vertical-center" style={{width: "20px"}} alt="warning" src={imgWarning} />
        ) : (
            ""
        );
    };

    getToOrder = () => {
        if (this.calculateToOrder() > 0) {
            return (
                <span className="margin-left-5">
                    (<Translate value="stock.toOrder" />
                    &nbsp;{this.calculateToOrder()})
                </span>
            );
        }
        return "";
    };

    getSubHeader = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex-child">
                    <div className="width-100per flex flex-child flex-align-center-vertical">
                        <div
                            className="color-square-big"
                            style={{
                                backgroundColor: this.state.colorantPackage.item.colorant.rgb
                            }}
                        />
                        <div className="color-primary margin-left-10 font-size-3rem ellipsis flex-child">
                            {this.state.colorantPackage.item.colorant.displayName}
                            <span className="color-secondary font-size-2rem margin-left-25">
                                ({this.state.colorantPackage.database})
                            </span>
                        </div>
                    </div>
                    <div className="width-100per flex flex-child font-size-0_75em">
                        <div className="flex-child">
                            <div className="width-100per flex-child flex">
                                <span>
                                    <Translate value="stock.onStock" />:
                                    <span className="color-black margin-left-5">
                                        {this.state.colorantPackage.currentValue}
                                    </span>
                                </span>
                                <div className="margin-left-30 color-warning flex flex-child">
                                    <ReactSVG
                                        className="vertical-center flex fill-warning flex-align-center width-25 react-svg-icon"
                                        alt="warning"
                                        src={imgCar}
                                    />
                                    <span className="margin-left-5">
                                        <Translate value="stock.inDelivery" />:
                                        <span className="margin-left-5">{this.state.colorantPackage.ordered}</span>
                                    </span>
                                </div>
                            </div>
                            <div
                                className={
                                    "width-100per flex-child flex " +
                                    (this.isSafe() ? "color-success fill-success" : "color-error fill-error")
                                }
                            >
                                <ReactSVG alt="prediction" className="width-2_5rem" src={imgPrediction} />
                                <span className="vertical-center margin-left-5">
                                    {translate("stock.consumptionPrediction", {weeks: 4})}
                                    {": "}
                                    {this.state.colorantPackage.prediction}
                                    <span className={"margin-left-5 color-black"}>{this.getToOrder()}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="margin-left-auto vertical-center col-4 flex">
                    <BarcodeImage id="barcode-cp-img" className="margin-left-auto" height="125vh" />
                </div>
            </React.Fragment>,
            "color-secondary"
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(this.getColorantPackageStockInfo());
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("stock.colorantInventory"))}
                subHeader={this.getSubHeader()}
                content={this.getContent()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        colorantPackages: store.stock.colorantPackages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseEditColorantPackagesInStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_COLORANT_PACKAGE_IN_STOCK_MODAL));
        },
        dispatchRemoveColorantPackageFromStockAction: (colorantPackageStock) => {
            dispatch(stockActions.removeColorantPackage(colorantPackageStock, true, true));
        },
        dispatchGetBarcodeAction: (colorant, pckg) => {
            dispatch(barcodeActions.getColorantPackageBarcode(colorant, pckg));
        }
    };
};

export default EditColorantPackageInStockModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(EditColorantPackageInStockModal);
